import React, { useState } from "react";
import {
  FaUserCircle,
  FaKey,
  FaUserAlt,
  FaRegUser,
  FaRegEnvelope,
  FaMapPin,
  FaBookOpen,
  FaSortNumericDown,
} from "react-icons/fa";
import SyncLoader from "react-spinners/SyncLoader";
import axios from "../../../../../api/axios";
import dashprofile from "../../../../../images/avatar/3.jpg";
import DashMenu from "../../../../atoms/DashMenu/DashMenu";
import "./Coperate.css";
import SubHeader from "../../../../atoms/SubHeader/SubHeader";

const Coperate = ({ toggleMenu, showMenu }) => {
  let COPERTAE_URL = "/api/cooperate/application";

  const [accountType, setAccountType] = useState("");
  const [firmName, setFirmName] = useState("");
  const [legalName, setLegalName] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [lga, setLga] = useState("");
  const [idType, setIdType] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [accName, setAccName] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [bvn, setBvn] = useState("");
  const [gender, setGender] = useState("");
  const [cacCert, setCacCert] = useState("");
  const [website, setWebsite] = useState("");
  const [cacReg, setCacReg] = useState("");
  const [accNumber, setAccNumber] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };

    try {
      const response = await axios.post(
        COPERTAE_URL,
        JSON.stringify({
          account_type: accountType,
          name_of_firm: firmName,
          legal_name: legalName,
          contact_address: address,
          state_of_origin: state,
          lga,
          id_type: idType,
          id_number: idNumber,
          bank_name: bankName,
          account_name: accName,
          account_number: accNumber,
          bvn,
          gender,
          cac_cert: cacCert,
          website_link: website,
          cac_reg_number: cacReg,
        }),
        config
      );
      console.log(response?.data);
      console.log(response?.accessToken);
      console.log(JSON.stringify(response));
      // navigate("/account-success");
      //clear state and controlled inputs
      //need value attrib on inputs for this
      setAccountType("");
      setAccName("");
      setAccNumber("");
      setAccountType("");
      setAddress("");
      setBankName("");
      setBvn("");
      setCacCert("");
      setCacReg("");
      setFirmName("");
      setGender("");
      setIdNumber("");
      setIdType("");
      setLegalName("");
      setLga("");
      setState("");
      setWebsite("");
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 409) {
        setErrMsg("Registration Failed");
      } else {
        setErrMsg("Registration Failed");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="dashboard-home-wrapper">
      <div className="dashmenu-style">
        <DashMenu toggleMenu={toggleMenu} showMenu={showMenu} />
      </div>{" "}
      <SubHeader title={"COPERATE APPLICATION"} />
      <div className="dash-edit-content-wrapper">
        <div className="edit-box edit-box1">
          <div className="edit-box-header">
            <FaUserCircle className="userprofile" />
            <h3>Change Avatar</h3>
          </div>
          <div className="edit-box-bg">
            <div className="edit-bg-1">
              <img src={dashprofile} alt="" />
              <p>Upload New Photo</p>
            </div>
            <div className="file-input">
              <input type="file" name="uuu" />
            </div>
          </div>
        </div>
        <div className="edit-box edit-box3">
          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="edit3-header">
              <FaKey className="userprofile" />
              <h3>Personal Info</h3>
            </div>
            <p
              className={errMsg ? "errmsg" : "offscreen"}
              arial-live="assertive"
            >
              {errMsg}
            </p>
            <div className="edit-info-wrap">
              <label for="myfile">Type</label>
              <div className="input-style">
                <select
                  data-placeholder="All Categories"
                  className="select-style"
                  onChange={(e) => setAccountType(e.target.value)}
                  value={accountType}
                >
                  <option value="all">Type</option>
                  <option value="cooperate">Cooperate Application</option>
                </select>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Legal Name *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaRegUser className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="legalname"
                    onChange={(e) => setLegalName(e.target.value)}
                    value={legalName}
                    required
                    placeholder="Legal Name"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Contact Address *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaMapPin className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="address"
                    onChange={(e) => setAddress(e.target.value)}
                    value={address}
                    required
                    placeholder="Contact Address"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">State *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaMapPin className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="state"
                    onChange={(e) => setState(e.target.value)}
                    value={state}
                    required
                    placeholder="State"
                  />{" "}
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Name of Firm *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaUserAlt className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="firmname"
                    onChange={(e) => setFirmName(e.target.value)}
                    value={firmName}
                    required
                    placeholder="Name of Firm"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">L.G.A *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaMapPin className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="lga"
                    onChange={(e) => setLga(e.target.value)}
                    value={lga}
                    required
                    placeholder="LOCAL GOVERNMENT AREA"
                  />{" "}
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Identity Type *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaRegEnvelope className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="idType"
                    onChange={(e) => setIdType(e.target.value)}
                    value={idType}
                    required
                    placeholder="Identity Type"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Identity Number *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaSortNumericDown className="userprofile" />
                  </div>
                  <input
                    type="number"
                    id="idNumber"
                    onChange={(e) => setIdNumber(e.target.value)}
                    value={idNumber}
                    required
                    placeholder="Identity Number"
                  />{" "}
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Bank Name *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaBookOpen className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="bankName"
                    onChange={(e) => setBankName(e.target.value)}
                    value={bankName}
                    required
                    placeholder="Bank Name"
                  />{" "}
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Account Name *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaBookOpen className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="accName"
                    onChange={(e) => setAccName(e.target.value)}
                    value={accName}
                    required
                    placeholder="Account Name"
                  />{" "}
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Account Number *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaSortNumericDown className="userprofile" />
                  </div>
                  <input
                    type="number"
                    id="accNumber"
                    onChange={(e) => setAccNumber(e.target.value)}
                    value={accNumber}
                    required
                    maxLength="11"
                    placeholder="Account Number"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">BVN *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaSortNumericDown className="userprofile" />
                  </div>
                  <input
                    type="number"
                    id="bvn"
                    onChange={(e) => setBvn(e.target.value)}
                    value={bvn}
                    required
                    placeholder="BVN"
                    aria-describedby="pwdnote"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">GENDER *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaUserAlt className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="gender"
                    onChange={(e) => setGender(e.target.value)}
                    value={gender}
                    required
                    placeholder="MALE OR FEMALE"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">cac_cert *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaBookOpen className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="cacCert"
                    onChange={(e) => setCacCert(e.target.value)}
                    value={cacCert}
                    required
                    placeholder="cac_cert"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">Website *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaBookOpen className="userprofile" />
                  </div>
                  <input
                    type="text"
                    id="website"
                    onChange={(e) => setWebsite(e.target.value)}
                    value={website}
                    placeholder="WEBSITE"
                  />
                </div>
              </div>
            </div>
            <div className="edit3-info">
              <div className="edit-info-wrap">
                <label htmlFor="myfile">cac_reg_number *</label>
                <div className="input-style">
                  <div className="input-icon">
                    <FaBookOpen className="userprofile" />
                  </div>
                  <input
                    type="number"
                    id="cacreg"
                    onChange={(e) => setCacReg(e.target.value)}
                    value={cacReg}
                    required
                    placeholder="cac_reg_number"
                  />
                </div>
              </div>
            </div>
            {isLoading ? (
              <div className="loading">
                <SyncLoader color={"#098FD2"} loading={isLoading} size={10} />
              </div>
            ) : (
              <button type="submit" className="save-changes">
                Save Changes
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Coperate;
